module.exports = __webpack_public_path__ + "img/20191123150800360截图20191123145331250.c78888b9.jpg";